module.exports = __webpack_public_path__ + "img/marshallislands.96be3f74.svg";